export default __webpack_public_path__ + "static/media/img-home1.91f6d03d.png";